import classNames from 'classnames';

import { HeroBannerWithFormFragmentFragment } from '../../__generated__/graphql';
import AppImage from '../../components/AppImage';
import Card from '../../components/Card';
import Content from '../../components/Content';
import { mapHeroBannerContent } from '../../components/Content/helpers';
import Form from '../../components/Form';
import { GradientText, Paragraph } from '../../components/Text';
import { ContentBlock } from '../types';

import textBaseStyle from '../../components/Text/text-base.module.css';
import style from './hero-banner-with-form.module.css';

const HeroBannerWithForm: ContentBlock<HeroBannerWithFormFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.heroBannerWithForm;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <section
      className={style.heroSection}
      id={contentBlockProps.sectionId ?? undefined}
    >
      <div className={style.heroBanner}>
        <div
          className={style.contentContainer}
        >
          <div className={style.textContainer}>
            <GradientText
              className={style.title}
              fontSize={48}
            >
              {contentBlockProps.title}
            </GradientText>

            {contentBlockProps.subtitle && (
              <Paragraph
                className={classNames(
                  style.subtitle,
                  textBaseStyle.fontSize18,
                )}
                fontWeight={700}
              >
                {contentBlockProps.subtitle}
              </Paragraph>
            )}

            {contentBlockProps.image && (
              <AppImage
                className={classNames(
                  style.image,
                  {
                    [style.imageMarginTop]: !!contentBlockProps.subtitle,
                  },
                )}
                fallbackHeight={400}
                fallbackWidth={550}
                image={contentBlockProps.image}
                priority
              />
            )}

            {contentBlockProps.content && (
              <Content content={mapHeroBannerContent(contentBlockProps.content)} />
            )}
          </div>
        </div>

        {contentBlockProps.form && (
          <Card
            backgroundColor="white"
            border="none"
            className={style.formCard}
          >
            <Form
              description={contentBlockProps.form.description}
              disclaimer={contentBlockProps.form.disclaimer}
              gravityForm={contentBlockProps.form.gravityForm}
              title={contentBlockProps.form.title}
            />
          </Card>
        )}
      </div>
    </section>
  );
};

export default HeroBannerWithForm;
